export default "__VITE_ASSET__G3hljaen__"